import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { FilterQuery } from '../../repository/types'
import type { User } from '../User'

@InputType()
export class GetUserArgs extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<User>
}

export interface IGetUser extends IAction<User, GetUserArgs> {}
